// ========================================
// PROTECTED ROUTE - AUTHENTICATION GUARD
// ========================================

import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import Login from './login';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();

    // Double-check: MSAL says authenticated but no accounts = force login
    const accounts = instance.getAllAccounts();
    const hasAccounts = accounts.length > 0;

    console.log('[ProtectedRoute] isAuthenticated:', isAuthenticated, 'hasAccounts:', hasAccounts);

    if (!isAuthenticated || !hasAccounts) {
        return <Login />;
    }

    return children;
};

export default ProtectedRoute;
